import { render, staticRenderFns } from "./TestDetail.vue?vue&type=template&id=454d9820"
import script from "./TestDetail.vue?vue&type=script&lang=js"
export * from "./TestDetail.vue?vue&type=script&lang=js"
import style0 from "./TestDetail.vue?vue&type=style&index=0&id=454d9820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports